// extracted by mini-css-extract-plugin
module.exports = {"table":"_3d-SxuuzPazDPO2MOnaq_y","tableCell":"_1kehV5fd8bY0pqa3DzbthP","tableLoadingOverlay":"_3Mgx2dRjALw8lektDcqSQf"};